module.exports = __webpack_public_path__ + "static/media/phone-handset-solid.25acab49.svg";